import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PremadeScriptView from "./premade-script-view";

const PremadeScriptDialog = ({ open, onClose, premadeId, version }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          height: "90vh",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle>
        Edit Premade Script
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 0, overflow: "hidden" }}>
        <PremadeScriptView
          premadeId={premadeId}
          version={version}
          onNavigateBack={onClose}
          isInDialog={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PremadeScriptDialog;
